const subscriptionBasedMan = [
	{
		id: '6101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt, T-shirt, Fatua)',
		description: 'Shirt-2pcs, T-shirt-2pcs, Fatua-2pcs',
		category: "Men's Wear",
		service: 'Subscription Based',
		price: 110,
		quantity: 1
	},
	{
		id: '6102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Presentation dress (Shirt, Pant, Tie)',
		description: 'Shirt-2pcs, Pant-2pcs, Tie-2pcs',
		category: "Men's Wear",
		service: 'Subscription Based',
		price: 85,
		quantity: 1
	},
	{
		id: '6103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater, Hoodie)',
		description: 'Sweater-2pcs, Hoodie-1pcs',
		category: "Men's Wear",
		service: 'Subscription Based',
		price: 90,
		quantity: 1
	},
	{
		id: '6104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (Blazer, Trouser, Waist Coat)',
		description: 'Blazer-2pcs, Trouser-3pcs, Waist Coat-2pcs',
		category: "Men's Wear",
		service: 'Subscription Based',
		price: 300,
		quantity: 1
	},
	{
		id: '6105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Marriage Set (Sherwani, Pant, Pajama, Panjabi)',
		description: 'Sherwani-1pcs, Pant-2pcs, Pajama-2pcs, Panjabi-2pcs',
		category: "Men's Wear",
		service: 'Subscription Based',
		price: 600,
		quantity: 1
	}
];
export default subscriptionBasedMan;
